<template>
  <div class="home">
    <!-- POP-UP -->
    <!--      <div class="modal fade" id="ModalWarning" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">-->
    <!--  <div class="modal-dialog modal-lg" role="document">-->
    <!--    &lt;!&ndash;Content&ndash;&gt;-->
    <!--    <div class="modal-content">-->
    <!--      &lt;!&ndash;Header&ndash;&gt;-->
    <!--      <div class="modal-header" style="height:70px;">-->
    <!--        <button type="button" class="close" data-dismiss="modal" aria-label="Close">-->
    <!--          <span aria-hidden="true" class="white-text" style="font-size:30px;">&times;</span>-->
    <!--        </button>-->
    <!--        <h3 style="color:white" >OPPORTUNITY</h3>-->
    <!--      </div>-->

    <!--      &lt;!&ndash;Body&ndash;&gt;-->
    <!--      <div class="modal-body">-->

    <!--        <div class="row">-->
    <!--          <div class="col-3 text-center">-->
    <!--            <img src="../assets/images/companylogo.png" alt="Logo" class=" z-depth-1-half rounded-circle" width="400">-->
    <!--            <div style="height: 10px"></div>-->
    <!--            <h5 style="color:white;">DO YOU WISH TO TRAVEL ABROAD?</h5>-->
    <!--            <h5 style="color:white;">ARE YOU A SKILLED OR UNSKILLED WORKER?</h5>-->
    <!--          </div>-->
    <!--                <br>-->
    <!--          <div class="col-9">-->
    <!--            <h5 style="color:white;">Here is a life changing opportunity for fellow Artisans(Drivers,Carpenters,Panelbeaters,Mechanics,e.t.c)</h5>-->
    <!--            <br>-->
    <!--            <h5 style="color:white;">WORK & LIVE in Dubai with just #350,000. Our services include;</h5>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--        <div class="row">-->
    <!--            <div class="col-3">-->
    <!--                <ul>-->
    <!--                    <li style="color:white; font-size:18px;"><i class="fa fa-check" style="color:#c9a63c;"></i>-->
    <!--                                Visa.-->
    <!--                            </li>-->
    <!--                    <li style="color:white; font-size:18px;"><i class="fa fa-check" style="color:#c9a63c;"></i>-->
    <!--                                Pick-up on arrival.-->
    <!--                    </li>-->
    <!--                    <li style="color:white; font-size:18px;"><i class="fa fa-check" style="color:#c9a63c;"></i>-->
    <!--                                Accomodation.-->
    <!--                    </li>-->
    <!--                </ul>-->
    <!--            </div>-->
    <!--            <br>-->
    <!--            <div class="col-9">-->
    <!--                <h5 style="color:#c9a63c; font-weight:900;">For further enquiries</h5>-->
    <!--                <ul>-->
    <!--                <li style="color:white; font-size:15px;"><i class="fa fa-phone" aria-hidden="true" style="color:#c9a63c;"></i> 08033370339, 08099523015</li>-->
    <!--                <li style="color:white; font-size:15px;"><i class="fa fa-envelope" aria-hidden="true" style="color:#c9a63c;"></i> info.niveau@gmail.com</li>-->
    <!--                </ul>-->
    <!--            </div>-->
    <!--        </div>-->


    <!--      </div>-->

    <!--      &lt;!&ndash;Footer&ndash;&gt;-->
    <!--      <div class="modal-footer justify-content-center">-->
    <!--        <a type="button" class="btn btn-outline-warning waves-effect btn-warning" data-dismiss="modal" style="color:white;">Great!<i class="far fa-gem ml-1 white-text"></i></a>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--    &lt;!&ndash;/.Content&ndash;&gt;-->
    <!--  </div>-->
    <!--</div>-->
    <!-- END  POPUP-->


    <div class="iq_wrapper">
      <!--Header Wrap Start-->
      <navigation/>
      <!--Header Wrap End-->
      <!--Banner Wrap Start-->


      <div id="myCarousel" class="carousel slide iq_banner carousel-fade" data-ride="carousel">
        <!-- Indicators -->
        <!-- <ol class="carousel-indicators">
            <li data-target="#myCarousel" data-slide-to="0" class="active" ></li>
            <li data-target="#myCarousel" data-slide-to="1" style="margin:0 10px"></li>
            <li data-target="#myCarousel" data-slide-to="2"></li>
        </ol> -->

        <!-- Wrapper for slides -->
        <div class="carousel-inner slider">
          <div class="item active" style="opacity:1">
            <img src="../assets/images/office.jpg" alt="Image here" id="ho" style="width:100%;">
            <div class="iq-caption-wrapper text-left">
              <div class="iq_banner_caption container">
                <div class="iq-caption animated slideInRight">
                  <!-- <div class="iq-caption-title">The Best Learning Institution</div> -->
                  <div class="iq-caption-text">Welcome to Le Niveau Consult.</div>
                  <div class="iq-caption-contant">Let's get you started to your education journey abroad</div>
                  <!-- form -->
                  <div class="container text-left fro">
                    <div class="row">
                      <div class="col-sm-4 dan">
                        <select class="form-control-lg" v-model="selectValue">
                          <option value="">I want to travel to</option>
                          <option value="Australia">Australia</option>
                          <option value="USA">USA</option>
                          <option value="Germany">Germany</option>
                          <option value="Ghana">Ghana</option>
                          <option value="UK">UK</option>
                          <option value="Dubai">Dubai</option>
                          <option value="Ireland">Ireland</option>
                          <option value="South America">South America</option>
                          <option value="Canada">Canada</option>
                          <option value="Netherlands">Netherlands</option>
                        </select>
                      </div>
                      <div class="col-sm-4 dan">
                        <select class="form-control-lg" v-model="optionValue">
                          <option value="">Purpose</option>
                          <option value="Undergraduate Studies">Undergraduate Studies</option>
                          <option value="Masters">Masters</option>
                          <option value="PHD">PHD</option>
                          <option value="Vacation">Vacation</option>
                          <option value="Others">Others</option>
                        </select>
                      </div>
                      <div class="col-sm-4 dan">
                        <button @click.prevent="saveVal" type="button" class="btn btn-danger btn-block btn-lg">GET
                          STARTED
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="item" style="opacity:1">
          <img src="../assets/extra-images/banner-2.jpg" style="background-color: rgba(248, 247, 216, 0.7);" alt="Image here" id="ho">
          <div class="iq-caption-wrapper text-center">
                  <div class="iq_banner_caption container">
                      <div class="iq-caption animated fadeIn">
                          <div class="iq-caption-text">Let your travel dreams come through</div>
                          <div class="iq-caption-contant">Just mention your dream country and let us handle the rest from Visa, Admission, and counselling </div>

                           <div class="container text-left fro">
                              <div class="row">
                            <div class="col-sm-4 dan">
                               <select class="form-control-lg">
                                  <option>I want to travel to</option>
                                  <option>Australia</option>
                                  <option>USA</option>
                                  <option>Canada</option>
                                  <option>Netherlands</option>
                                  </select>
                            </div>
                            <div class="col-sm-4 dan">
                                <select class="form-control-lg">
                                  <option>Purpose</option>
                                  <option>Undergarduate studies</option>
                                  <option>Masters</option>
                                  <option>PHD</option>
                                  <option>Vacation</option>
                                  <option>Others</option>
                                  </select>
                            </div>
                            <div class="col-sm-4 dan">
                               <button  @click="$router.push('apply')" type="button" class="btn btn-danger btn-block btn-lg">GET STARTED</button>
                            </div>
                            </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div> -->

          <!-- <div class="item" style="opacity:1; background-color: rgba(248, 247, 216, 0.7);">
          <img src="../assets/extra-images/banner-3.jpg" style="background-color: rgba(248, 247, 216, 0.7);" alt="Image here" id="ho">
          <div class="iq-caption-wrapper text-right">
                  <div class="iq_banner_caption container">
                      <div class="iq-caption animated slideInLeft">
                          <div class="iq-caption-text">Not sure of which country to travel for vacation or studies?</div>
                          <div class="iq-caption-contant">Let's talk. We have over 10 years experience in travels vacations arrangement. </div>

                          <div class="container text-left fro">
                              <div class="row py-5">
                            <div class=" col-sm-4 dan">
                               <select class="form-control-lg">
                                  <option>I want to travel to</option>
                                  <option>Australia</option>
                                  <option>USA</option>
                                  <option>Canada</option>
                                  <option>Netherlands</option>
                                  </select>
                            </div>
                            <div class="col-sm-4 dan">
                                <select class="form-control-lg">
                                  <option>Purpose</option>
                                  <option>Undergraduate Studies</option>
                                  <option>Masters</option>
                                  <option>PHD</option>
                                  <option>Vacation</option>
                                  <option>Others</option>
                                  </select>
                            </div>
                            <div class=" col-sm-4 dan">
                                <button @click="$router.push('apply')" type="button" class="btn btn-danger btn-block btn-lg">GET STARTED</button>
                            </div>
                            </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>    -->
        </div>
        <!-- Left and right controls -->
        <!-- <a class="left carousel-control" href="#myCarousel" data-slide="prev">
            <span class="glyphicon glyphicon-chevron-left"></span>
            <span class="sr-only">Previous</span>
        </a>
        <a class="right carousel-control" href="#myCarousel" data-slide="next">
            <span class="glyphicon glyphicon-chevron-right"></span>
            <span class="sr-only">Next</span>
        </a> -->
      </div>
      <!--Banner Wrap End-->

      <!--Iqoniq Content Start-->
      <div class="iq_content_wrap" style="margin-top:30px">
        <!--We Are Professional Wrap Start-->
        <div class="we_professional_bg">
          <div class="container">
            <!--Upcomming List Wrap Start-->

            <!--UpComming Event Start-->
            <div class="row">
              <div class="col-md-3 col-sm-6">
                <div class="iq_upcomming_event">
                  <figure>
                    <img src="../assets/extra-images/direct_placements.jpg" class="img-responsive" alt="Image Here">
                  </figure>
                  <div class="iq_upcomming_des">
                    <small>Immediately Start your admission processing into any institution of your choice now.</small>
                    <h6><a href="#">Admission Processing</a></h6>
                  </div>
                </div>
              </div>
              <!--UpComming Event End-->
              <!--UpComming Event Start-->
              <div class="col-md-3 col-sm-6">
                <div class="iq_upcomming_event">
                  <figure>
                    <img src="../assets/images/guest.jpg" class="img-responsive" alt="Image Here">
                  </figure>
                  <div class="iq_upcomming_des">
                    <small> We help students work through their difficulties as they select the right course at the
                      right university.</small>
                    <h6><a href="#">Student Counselling</a></h6>
                  </div>
                </div>
              </div>
              <!-- UpComming Event End -->
              <!--UpComming Event Start-->
              <div class="col-md-3 col-sm-6">
                <div class="iq_upcomming_event one">
                  <figure>
                    <img src="../assets/extra-images/visa_application.jpg" class="img-responsive" alt="Image Here">
                  </figure>
                  <div class="iq_upcomming_des">
                    <small>We help students with visa application, processing and documentation</small>
                    <h6><a href="#">Visa Processing</a></h6>
                  </div>
                </div>
              </div>
              <!--UpComming Event End-->
              <!--UpComming Event Start-->
              <div class="col-md-3 col-sm-6">
                <div class="iq_upcomming_event one">
                  <figure>
                    <img src="../assets/extra-images/tour.jpg" alt="Image Here">
                  </figure>
                  <div class="iq_upcomming_des">
                    <small>We help you get the best places in the world for your tour.</small>
                    <h6><a href="#">Tour</a></h6>
                  </div>
                </div>
              </div>
              <!--UpComming Event End-->
            </div>
          </div>
        </div>


      </div>
      <!--Upcomming List Wrap End-->


      <!--We Are Professional Wrap End-->


      <!--Get Best Knowledge Wrap Start-->
      <section class="iq_best_knowledge_bg">
        <!--Best Knowledge Description Wrap Start-->
        <div class="row">
          <div class="col-md-6">
            <div class="embed-responsive embed-responsive-16by9">

              <iframe width="854" height="480" src="https://www.youtube.com/embed/P1Zha2CrJZ0" frameborder="0"
                      allowfullscreen=""></iframe>
            </div>
          </div>
          <div class="col-md-6 ">
            <div class="iq_knowledge_des">
              <!--Heading Wrap Start-->
              <div class="iq_heading_1 text-left">
                <h4><span> Unique Travel experience </span></h4>
              </div>
              <!--Heading Wrap End-->
              <h5>Have the best travel experience ever</h5>
              <p>Le Niveau Consult is an organization devoted to facilitating the placement of young students into top
                educational institutions around thee world.</p>
              <a class="iq_link_1" href="https://forms.gle/3W1Egx6AgdPC7y9E9" target="_blank">Get started</a>
            </div>
          </div>
        </div>

        <!--Best Knowledge Description Wrap Start-->
      </section>
      <!--Get Best Knowledge Wrap End-->
      <!--Our Featured Courses Wrap Start-->

      <!--Our Gallery Wrap Start-->
      <section class="iq_gallery_bg">
        <!--Heading Wrap Start-->
        <div class="iq_heading_1 text-center">
          <h4>TOP RATED <span>RECOMMENDED SCHOOLS</span></h4>
          <p>This recommendation is based on ranking.
            <br> We can always give you in depth recommendation when you contact us</p>
        </div>
        <!--Heading Wrap End-->
        <!--Gallery Menu Wrap Start-->

        <!--Gallery Menu Wrap End-->
        <div id="" class=" main-gallery row" style="float:left">
          
          <div class="col-md-4 col-xs-6  " style="display:block">
            <div class="thumb">
              <figure>
                <img src="../assets/extra-images/jcu.jpeg" alt="Image Here">
                <figcaption class="overlay1">
                  <div class="link-wrapper">
                    <!-- <a href="#"><i class="fa fa-search"></i></a> -->
                    <a href="#"><i class="fa fa-link"></i></a>
                    <h6 class=""> James Cook university in Australia</h6>
                    <div class=""><i class="fa fa-map-marker"></i>Netherlands</div>
                    <!-- <p>James Cook University is a public university and is the second oldest university in Queensland, Australia. </p> -->
                  </div>
                </figcaption>
              </figure>
            </div>
          </div>
          <div class="col-md-4 col-xs-6 ">
            <div class="thumb">
              <figure>
                <img src="../assets/extra-images/tuo.jpeg" alt="Image Here">
                <figcaption class="overlay1">
                  <div class="link-wrapper">
                    <a href="#"><i class="fa fa-link"></i></a>
                    <h6>TRENT UNIVERSITY, ONTARIO</h6>
                    <div class=""><i class="fa fa-map-marker"></i> Canada</div>
                  </div>
                </figcaption>
              </figure>
            </div>
          </div>
          <div class="col-md-4 col-xs-6 ">
            <div class="thumb">
              <figure>
                <img src="../assets/extra-images/uca.webp" alt="Image Here">
                <figcaption class="overlay1">
                  <div class="link-wrapper">
                    <a href="#"><i class="fa fa-link"></i></a>
                    <h6>UNIVERSITY OF CALIFORNIA, IRVINE</h6>
                    <div class=""><i class="fa fa-map-marker"></i> USA</div>
                  </div>
                </figcaption>
              </figure>
            </div>
          </div>
          <div class="col-md-4 col-xs-6 ">
            <div class="thumb">
              <figure>
                <img src="../assets/extra-images/fontys.jpg" alt="Image Here">
                <figcaption class="overlay1">
                  <div class="link-wrapper">
                    <a href="#"><i class="fa fa-link"></i></a>
                    <h6>FONTYS UNIVERSITY OF APPLIED SCIENCES</h6>
                    <div class=""><i class="fa fa-map-marker"></i>Netherlands</div>
                  </div>
                </figcaption>
              </figure>
            </div>
          </div>
          <div class="col-md-4 col-xs-6 ">
            <div class="thumb">
              <figure>
                <img src="../assets/extra-images/ulu.jpg" alt="Image Here">
                <figcaption class="overlay1">
                  <div class="link-wrapper">
                    <a href="#"><i class="fa fa-link"></i></a>
                    <h6>UNIVERSITY OF NORTHAMPTON</h6>
                    <div class=""><i class="fa fa-map-marker"></i> England</div>
                  </div>
                </figcaption>
              </figure>
            </div>
          </div>
          <div class="col-md-4 col-xs-6 ">
            <div class="thumb">
              <figure>
                <img src="../assets/extra-images/nci.jpg" alt="Image Here">
                <figcaption class="overlay1">
                  <div class="link-wrapper">
                    <a href="#"><i class="fa fa-link"></i></a>
                    <h6>NATIONAL COLLEGE OF IRELAND</h6>
                    <div class=""><i class="fa fa-map-marker"></i> Dublin</div>
                  </div>
                </figcaption>
              </figure>
            </div>
          </div>
          <div class="col-md-4 col-xs-6 ">
            <div class="thumb">
              <figure>
                <img src="../assets/extra-images/alu.jpg" alt="Image Here">
                <figcaption class="overlay1">
                  <div class="link-wrapper">
                    <a href="#"><i class="fa fa-link"></i></a>
                    <h6>ALGOMA UNIVERSITY</h6>
                    <div class=""><i class="fa fa-map-marker"></i> Canada</div>
                  </div>
                </figcaption>
              </figure>
            </div>
          </div>
          <div class="col-md-4 col-xs-6 ">
            <div class="thumb">
              <figure>
                <img src="../assets/extra-images/rgu.jpg" alt="Image Here">
                <figcaption class="overlay1">
                  <div class="link-wrapper">
                    <a href="#"><i class="fa fa-link"></i></a>
                    <h6>ROBERT GORDON UNIVERSITY</h6>
                    <div class=""><i class="fa fa-map-marker"></i> Scotland</div>
                  </div>
                </figcaption>
              </figure>
            </div>
          </div>
        </div>
        <!-- <div class="load-more">
            <a class="iq_link_1" href="#">LOAD MORE</a>
        </div> -->
      </section>
      <!--Our Gallery Wrap End-->
      <!--UpComming Event Wrap Start-->

      <!--UpComming Event Wrap End-->
      <!--Number Counter Wrap Start-->
      <section class="iq_number_count_bg">
        <div class="container">
          <div class="row">
            <!--Number Counter Start-->
            <div class="col-md-2 col-sm-6">
              <div class="iq_counter">
                <i class="fa fa-ticket"></i>
                <span class="counter">2025</span>
                <h6>Admision Processed</h6>
              </div>
            </div>
            <!--Number Counter End-->
            <!--Number Counter Start-->
            <div class="col-md-2 col-sm-6 ">
              <div class="iq_counter">
                <i class="fa fa-globe"></i>
                <span class="counter">980</span>
                <h6>Holidays</h6>
              </div>
            </div>
            <!--Number Counter End-->
            <!--Number Counter Start-->
            <div class="col-md-2 col-sm-6">
              <div class="iq_counter">
                <i class="fa fa-skyatlas"></i>
                <span class="counter">438</span>
                <h6>Tour</h6>
              </div>
            </div>
            <!--Number Counter End-->
            <!--Number Counter Start-->
            <div class="col-md-2 col-sm-6">
              <div class="iq_counter">
                <i class="fa fa-tasks"></i>
                <span class="counter">324</span>
                <h6>Students Counselling</h6>
              </div>
            </div>
            <!--Number Counter End-->
            <!--Number Counter Start-->
            <div class="col-md-2 col-sm-6">
              <div class="iq_counter">
                <i class="fa fa-tag"></i>
                <span class="counter">50</span>
                <h6>Affiliated Schools</h6>
              </div>
            </div>
            <!--Number Counter End-->
            <!--Number Counter Start-->
            <div class="col-md-2 col-sm-6">
              <div class="iq_counter">
                <i class="fa fa-plane"></i>
                <span class="counter">1960</span>
                <h6>Visas</h6>
              </div>
            </div>
            <!--Number Counter End-->
          </div>
        </div>
      </section>
      <!--Number Counter Wrap End-->
      <!--Our Teacher Wrap Start-->

      <!--Our Teacher Wrap End-->
      <!--Our Blog Slider Start-->

      <!--Our Blog Slider End-->


      <!--Testimonial Slider Wrap Start-->

      <section>
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div class="carousel slide" data-ride="carousel" id="quote-carousel">

                <!-- Carousel Slides / Quotes -->
                <div class="carousel-inner">

                  <!-- Quote 1 -->
                  <div class="item active">
                    <div class="row">
                      <div class="col-sm-12">
                        <img class="img-fluid" src="../assets/images/testimonial/jude.png" alt="" width="150">
                        <p id="jos">&ldquo;I was impressed by their level of experience. I thought it would not be
                          possible for me to travel abroad but Le Niveau Consult made my study abroad dream a reality.&rdquo;</p>
                        <h5>Osemene Jude</h5>
                        <small>Computer Engineering student<br>Ulster University, Northern Ireland, UK</small>
                      </div>
                    </div>
                  </div>

                  <!-- Quote 2 -->
                  <div class="item">
                    <div class="row">
                      <div class="col-sm-12">
                        <img class="img-fluid" src="../assets/images/testimonial/tuvie.png" alt="" width="170">
                        <p id="jos">&ldquo;They made school admission, visa processing quite easy for me, I delight in
                          them alot.&rdquo;</p>
                        <h5>Tuvie Akpofure</h5>
                        <small>Cyber security masters student, <br>National college of Ireland</small>
                      </div>
                    </div>
                  </div>

                  <!-- Quote 3 -->
                  <div class="item">
                    <div class="row">
                      <div class="col-sm-12">
                        <img class="img-fluid" src="../assets/images/testimonial/joseph.png" alt="" width="200">
                        <p id="jos">&ldquo;Trusted agency! study, live and work abroad with a few easy steps. Nice one
                          Le Niveau Consult.&rdquo;</p>
                        <h5>Iribhogbe Joseph</h5>
                        <small>International Business student(Master), <br>National College of Ireland</small>
                      </div>
                    </div>
                  </div>
                  <!-- Bottom Carousel Indicators -->
                  <ol class="carousel-indicators">
                    <li data-target="#quote-carousel" data-slide-to="0" class="active"></li>
                    <li data-target="#quote-carousel" data-slide-to="1"></li>
                    <li data-target="#quote-carousel" data-slide-to="2"></li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!--Testimonial Slider Wrap End-->
    </div>
    <!--Iqoniq Content End-->
    <!--Brand Slider Start-->

    <!-- <div class="brnd-slider-wrap">
        <div class="container">
            <div class="brnd-slider">
                <slick ref="slick" :options="slickOptions">
                    <div>
                        <a href="#" class="thumb">
                            <img src="../assets/extra-images/brand1.png" alt="">
                        </a>
                    </div>
                    <div>
                        <a href="#" class="thumb">
                            <img src="../assets/extra-images/brand2.png" alt="">
                        </a>
                    </div>
                    <div>
                        <a href="#" class="thumb">
                            <img src="../assets/extra-images/brand3.png" alt="">
                        </a>
                    </div>
                    <div>
                        <a href="#" class="thumb">
                            <img src="../assets/extra-images/brand4.png" alt="">
                        </a>
                    </div>
                    <div>
                        <a href="#" class="thumb">
                            <img src="../assets/extra-images/brand5.png" alt="">
                        </a>
                    </div>
                    <div>
                        <a href="#" class="thumb">
                            <img src="../assets/extra-images/brand6.png" alt="">
                        </a>
                    </div>
                    <div>
                        <a href="#" class="thumb">
                            <img src="../assets/extra-images/brand1.png" alt="">
                        </a>
                    </div>
                </slick>
            </div>
        </div>
    </div> -->
    <!--Brand Slider End-->
    <div class="container">

    </div>
    <!-- footer -->
    <Footers/>
  </div>

</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import Slick from 'vue-slick';
import navigation from './navigation.vue'
import Footers from './footer.vue'

export default {
  name: 'home',
//   props: ["dl_active", "dl_menuopen"],
  components: {
    Slick,
    navigation,
    Footers
    // HelloWorld
  },
  data() {
    return {
      slickOptions: {
        slidesToShow: 1,
        swipeToSlide: false,
        // Any other options that can be got from plugin documentation

      },
      selectValue: "",
      optionValue: "",
    };
  },
  methods: {
    next() {
      this.$refs.slick.next();
    },

    prev() {
      this.$refs.slick.prev();
    },
    handleBreakpoint(event, slick, breakpoint) {
      console.log('handleBreakpoint', event, slick, breakpoint);
    },
    saveVal() {
      sessionStorage.setItem("destination", this.selectValue);
      sessionStorage.setItem("purpose", this.optionValue);
      this.$router.push('Application');
    },

  },
  created() {
    $('.carousel').carousel({
      interval: 10000
    });

  }
};

$(document).ready(function () {
  //carousel options
  $('#quote-carousel').carousel({
    pause: true, interval: 10000,
  });
});

$(document).ready(function () {
  $("#ModalWarning").modal('show');
});


</script>


<style scoped>
#quote-carousel {
  padding: 0 10px 30px 10px;
  margin-top: 60px;
}

#quote-carousel .carousel-control {
  background: none;
  color: #CACACA;
  font-size: 2.3em;
  text-shadow: none;
  margin-top: 30px;
}

#quote-carousel .carousel-indicators {
  position: relative;
  right: 50%;
  top: auto;
  bottom: 0px;
  margin-top: 20px;
  margin-right: -19px;
}

#quote-carousel .carousel-indicators li {
  width: 50px;
  height: 50px;
  cursor: pointer;
  border: 1px solid #c9a63c;
  /* box-shadow: 0 0 5px rgba(0, 0, 0, 0.1); */
  border-radius: 50%;
  opacity: 0.4;
  overflow: hidden;
  transition: all .4s ease-in;
  vertical-align: middle;
}

#quote-carousel .carousel-indicators .active {
  width: 128px;
  height: 128px;
  opacity: 1;
  transition: all .2s;
}

.item blockquote {
  border-left: none;
  margin: 0;
}

.item blockquote h5 {
  color: #c9a63c;
}

.item blockquote p:before {
  content: "\f10d";
  color: #c9a63c;
  font-family: 'Fontawesome';
  float: left;
  margin-right: 10px;
}

/* .myCarousel{
    position: relative;
} */
@media only screen and (max-width: 768px) {
  .slick {
    display: none !important
  }

  .sm-testimonial {
    display: block !important
  }

}

.carousel.carousel-fade .item {
  -webkit-transition: opacity 1000s ease-in-out;
  -moz-transition: opacity 1000s ease-in-out;
  -ms-transition: opacity 1000s ease-in-out;
  -o-transition: opacity 1000s ease-in-out;
  transition: opacity 1000s ease-in-out;
  opacity: 0;
}

.carousel.carousel-fade .active.item {
  opacity: 1;
}

.carousel.carousel-fade .active.left,
.carousel.carousel-fade .active.right {
  left: 0;
  z-index: 2;
  opacity: 0;
  filter: alpha(opacity=0);
}

.carousel.carousel-fade .next,
.carousel.carousel-fade .prev {
  left: 0;
  z-index: 1;
}

.carousel.carousel-fade .carousel-control {
  z-index: 3;
}

.iq_heading_1 h4:before {
  background-color: #c9a63c;
}

.iq_upcomming_des h6 a {
  color: #fff !important
}

/*-- blog--*/

.blog-txt-info {
  background: #fff;
  padding: 1em 1em;
}

.news-date ul li a {
  letter-spacing: 2px;
  color: #222;
  text-decoration: none;
  font-weight: 600;
  font-size: 12px;
}

.clients-color, .team-shadow {
  box-shadow: 2px 0px 20px 0px #757575;
}

/*-- //blog--*/

@media (max-width: 480px) {
  .iq-caption-text {
    font-size: 20px !important;
  }

  .iq_link_1 {
    font-size: 14px !important
  }
}

@media (max-width: 767px) {

  .iq-caption-text {
    font-size: 25px !important;
    margin: 0 0 15px;
  }
}

/* form */
.fro {
  background-color: rgb(255, 225, 142);
  margin-top: 100px;
  border-radius: 5px;
}

@media only screen and (min-width: 320px) and (max-width: 920px) {
  #ho {
    height: 500px;
  }
}

.dan {
  margin: 15px 0px 15px 0px;
}

#ho {
  filter: brightness(50%);
}

/* TE */
/* carousel */
#quote-carousel {
  padding: 0 10px 30px 10px;
  margin-top: 30px;
  text-align: center;
}

/* indicator position */
#quote-carousel .carousel-indicators {
  right: 50%;
  top: auto;
  bottom: -10px;
  margin-right: -19px;
}

/* indicator color */
#quote-carousel .carousel-indicators li {
  background: #c0c0c0;
}

/* active indicator */
#quote-carousel .carousel-indicators .active {
  background: #333333;
  height: 10px;
  width: 10px;
  margin-bottom: 1px;
}

/* typography */
h1 {
  text-align: center;
  margin-bottom: -20px !important;
}

.img-fluid {
  border-radius: 50%;
  border: 2px solid #c9a63c;
  box-shadow: 12px 2px #c9a63c;
}

#jos {
  font-size: 18px;
  font-weight: 600;
  color: black;
}

.modal-header {
  background-color: #c9a63c;
}

.modal-content {
  background-image: linear-gradient(-30deg, rgb(58, 96, 173), #e7c151); /* Standard syntax (must be last) */
}
</style>
